/**
 * Adzuki. My Settings - Shipping list actions
 *
 * SET-60, decision B3: the two mutating actions on the Shipping list are POSTs.
 *
 * THEY WERE GET LINKS. "Make preferred" and "delete" were plain hrefs, which is the CSRF-on-GET
 * exposure B3 exists to close and is also fetchable by anything that follows links - a crawler,
 * a link preview, a security scanner. Both now post to their own endpoint and the panel is
 * re-rendered from the server afterwards, so what the advisor sees is what was stored rather
 * than what this file assumed.
 *
 * SET-133 MOVED THE MACHINERY OUT. The ajax, the three answers a list endpoint can give and the
 * delegated binding now live in my_settings_list_actions.js, shared with Credit Cards and
 * Franchise Documents. What is left is this panel's own facts - what to bind, where to post and
 * what to say if the request never completes.
 *
 * THE PREFERRED RADIO GAINED A FIX IN THAT MOVE. A refused /MySettings/shippingPreferred used to
 * notify and stop, leaving the radio the advisor clicked selected against a record that was
 * never stored; the shared helper re-reads the panel on every non-success answer, so it goes
 * back to the stored value. See the RELOAD ON EVERY NON-SUCCESS note there.
 *
 * NOTHING HERE WRITES ADVISOR-FACING COPY apart from the two last-resort failure strings below.
 * Success and refusal text comes from the response, and the delete confirmation is raised BY THE
 * SERVER - shippingDelete() answers an unconfirmed request with a confirmation_prompt rather
 * than deleting, exactly as a form's confirm() does. So the wording of an irreversible-delete
 * warning lives next to the code that performs the delete.
 */

(function MySettingsShipping($, Adzuki)
{
	"use strict";

	// INSIDE ready, NOT AT LOAD, AND THE SAME IN ALL THREE PANELS. gulp concatenates
	// js/Adzuki/*.js by filename, so my_settings_documents.js and my_settings_financial.js both
	// run BEFORE my_settings_list_actions.js and the helper is not assigned yet at that point in
	// the bundle. Every script has executed by the time a ready callback fires, so registering
	// here makes the panels independent of where the helper happens to sort - which is a
	// filename away from changing.
	$(document).ready(function documentReady() {
		if (!Adzuki.MySettings || !Adzuki.MySettings.ListActions) {
			return;
		}

		Adzuki.MySettings.ListActions.bind({
			url    : '/MySettings/shipping',
			actions: [
				{
					event   : 'change',
					selector: '.my-settings-preferred',
					url     : function preferred($control) {
						return '/MySettings/shippingPreferred/' + $control.val();
					},
					failure: 'There was an error attempting to set the preferred shipping account.'
				},
				{
					// SET-52 RENAMED THIS FROM THE BARE data-my-settings-delete. bind() delegates from the
					// whole overlay on the selector alone, with no per-panel scoping, so a generic name is
					// a collision waiting for the next list panel - one click would fire both handlers and
					// their answers would race to reload the panel. This one had the generic name only
					// because it was the first list built; Blackout, Documents, Credit Cards and Invoice
					// Notes all took a specific one. Now none is generic.
					event   : 'click',
					selector: '[data-my-settings-shipping-delete]',
					url     : function remove($control) {
						return '/MySettings/shippingDelete/' + $control.attr('data-my-settings-shipping-delete');
					},
					failure: 'There was an error attempting to delete the shipping account.'
				}
			]
		});
	});
}(jQuery, window.Adzuki || {}));
